// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../../styles/FindMatter/FindMatter.css";

// interface MatterFields {
//   "Matter Name": string; // Airtable field name (as in your JSON)
// }

// interface AirtableRecord {
//   id: string;
//   fields: MatterFields;
// }

// interface FindMatterResponse {
//   results: AirtableRecord[];
// }

// interface FindMatterProps {
//   user?: CometChat.User;
// }

// const FindMatter: React.FC<FindMatterProps> = ({ user }) => {
//   const [matterNames, setMatterNames] = useState<string[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   // Get full name from CometChat user and extract first name
//   const fullName = user?.getName?.() || ""; // e.g., "Donald Trump Portal"
//   const firstName = fullName.split(" ")[0] || "";

//   useEffect(() => {
//     if (!firstName) return;

//     setLoading(true);
//     setError(null);

//     axios
//       .get<FindMatterResponse>("http://localhost:5000/api/airtable/find-matter", {
//         params: { name: firstName },
//       })
//       .then((res) => {
//         // Map results to array of matter names
//         const names = res.data.results.map((r) => r.fields["Matter Name"]);
//         setMatterNames(names);
//       })
//       .catch((err) => {
//         console.error(err);
//         setError("Failed to load matters");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [firstName]);

//   return (
//     <div className="app-layout">
//       <aside className="sidebar">
//         <div className="matter-section-inline">
//           {/* <h3>Matters for {fullName}</h3> */}
//           {loading && <p>Loading matters...</p>}
//           {error && <p style={{ color: "red" }}>{error}</p>}
//           {!loading && !error && matterNames.length === 0 && (
//             <p className="matter-name-inline">No matters found</p>
//           )}
//           {!loading && !error && matterNames.length > 0 && (
//             matterNames.map((name, idx) => (
//               <div key={idx} className="matter-name-inline">
//                 {name}
//               </div>
//             ))
//           )}
//         </div>
//       </aside>
//     </div>
//   );
// };

// export default FindMatter;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../../styles/FindMatter/FindMatter.css";
// import { CometChat } from "@cometchat/chat-sdk-javascript";

// interface MatterFields {
//   "Matter Name": string;
// }

// interface AirtableRecord {
//   id: string;
//   fields: MatterFields;
// }

// interface FindMatterResponse {
//   results: AirtableRecord[];
// }

// interface FindMatterProps {
//   user?: CometChat.User;
//   group?: string | null; // conversationId or guid
//   type?: string | null;
// }

// const normalizeGroupId = (id?: string): string => {
//   if (!id) return "";

//   if (id.startsWith("group_group_")) {
//     return id.replace("group_group_", "group_");
//   }

//   return id;
// };

// const FindMatter: React.FC<FindMatterProps> = ({ user, group }) => {
//   const [matterNames, setMatterNames] = useState<string[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   // Get full name from CometChat user and extract first name
//   const fullName = user?.getName?.() || ""; // e.g., "Donald Trump Portal"
//   const firstName = fullName.split(" ")[0] || "";

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!group) return;

//       try {
//         setLoading(true);
//         setError(null);

//         // 🔥 Normalize GUID
//         const guid = normalizeGroupId(group);

//         // 🔥 Get group from SDK
//         const groupObj = await CometChat.getGroup(guid);
//         console.log("groupObj->", groupObj);

//         const groupName = groupObj.getName() || "";

//         // 🔥 Airtable API (UNCHANGED)
//         const res = await axios.get<FindMatterResponse>(
//           "http://localhost:5000/api/airtable/find-matter",
//           {
//             params: { name: firstName },
//           }
//         );

//         // 🔥 Filter ONLY matching matter name === group name
//         const matchedNames = res.data.results
//           .map((r) => r.fields["Matter Name"])
//           .filter((name) => name === groupName);

//         setMatterNames(matchedNames);

//       } catch (err) {
//         console.error(err);
//         // setError("Failed to load matters");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [group]);

//   return (
//     <div className="app-layout">
//       <aside className="sidebar">
//         <div className="matter-section-inline">

//           {/* {!group && (
//             <p className="matter-name-inline">Select a group</p>
//           )} */}

//           {loading && <p>Loading matters...</p>}

//           {error && <p style={{ color: "red" }}>{error}</p>}

//           {!loading && !error && matterNames.length === 0 && (
//             <p className="matter-name-inline">No matters found</p>
//           )}

//           {!loading &&
//             !error &&
//             matterNames.map((name, idx) => (
//               <div key={idx} className="matter-name-inline">
//                 {name}
//               </div>
//             ))}

//         </div>
//       </aside>
//     </div>
//   );
// };

// export default FindMatter;

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../../styles/FindMatter/FindMatter.css";
import { CometChat } from "@cometchat/chat-sdk-javascript";

interface MatterFields {
  "Matter Name": string;
}

interface AirtableRecord {
  id: string;
  fields: MatterFields;
}

interface FindMatterResponse {
  results: AirtableRecord[];
}

interface FindMatterProps {
  user?: CometChat.User;
  group?: string | null;
  type?: string | null; // "group" | "user"
}

const normalizeGroupId = (id?: string): string => {
  if (!id) return "";
  if (id.startsWith("group_group_")) {
    return id.replace("group_group_", "group_");
  }
  return id;
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API_BASE_URL->", API_BASE_URL);

const FindMatter: React.FC<FindMatterProps> = ({ user, group, type }) => {
  const [matterNames, setMatterNames] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const lastLoadedKey = useRef<string | null>(null);

  // 🔥 User first name (UNCHANGED)
  const fullName = user?.getName?.() || "";
  const firstName = fullName.split(" ")[0] || "";

  useEffect(() => {
    const key = `${type}-${group || firstName}`;
    if (!type || lastLoadedKey.current === key) return;

    lastLoadedKey.current = key;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // ============================
        // 👤 USER CHAT → SHOW FIRST MATTER
        // ============================
        if (type === "user") {
          if (!firstName) return;

          const res = await axios.get<FindMatterResponse>(
            `${API_BASE_URL}/airtable/find-matter`,
            {
              params: { name: firstName },
            }
          );

          const firstMatter =
            res.data.results[0]?.fields["Matter Name"] || null;

          setMatterNames(firstMatter ? [firstMatter] : []);
          // setMatterNames([]);
          return;
        }

        // ============================
        // 👥 GROUP CHAT → MATCH GROUP NAME
        // ============================
        if (type === "group" && group) {
          const guid = normalizeGroupId(group);

          // From :contentReference[oaicite:0]{index=0} SDK
          const groupObj = await CometChat.getGroup(guid);
          const groupName = groupObj.getName() || "";

          const res = await axios.get<FindMatterResponse>(
            `${API_BASE_URL}/airtable/find-matter`,
            {
              params: { name: firstName },
            }
          );

          const matched = res.data.results
            .map((r) => r.fields["Matter Name"])
            .filter((name) => name === groupName);

          setMatterNames(matched);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load matters");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [type, group, firstName]);

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="matter-section-inline">
          {loading && <p>Loading matters...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
          {!loading && !error && matterNames.length === 0 && (
            <p className="matter-name-inline">No matters found</p>
          )}
          {!loading &&
            !error &&
            matterNames.map((name, idx) => (
              <div key={idx} className="matter-name-inline">
                {name}
              </div>
            ))}
          <div className="cometchat-conversations-header"></div>
        </div>
      </aside>
    </div>
  );
};

export default FindMatter;

// const FindMatter: React.FC<FindMatterProps> = ({ user }) => {
//     console.log("user->", user);
//     const [matterName, setMatterName] = useState<string>("");

//     useEffect(() => {
//         axios
//             .get<FindMatterResponse>(
//                 "http://localhost:5000/api/airtable/find-matter",
//                 { params: { name: "Anas" } }
//             )
//             .then((res) => {
//                 setMatterName(res.data.results?.[0]?.fields?.MatterName || "");
//             });
//     }, []);

//     return (
//         <div className="app-layout">
//             <aside className="sidebar">
//                 <div className="matter-section-inline">
//                     <span className="matter-name-inline">{matterName || "—"}</span>
//                 </div>
//             </aside>
//         </div>
//     );
// };

// export default FindMatter;